import {
  MODEL_ACCURACY_THRESHOLD,
  MODEL_BUSINESS_ERROR_THRESHOLD,
  MODEL_MAPE_THRESHOLD
} from "@constants/model_kpis";
import { Theme } from "@mui/material";

export const getModelAccuracyColor = (value: number, theme: Theme): string => {
  if (value < MODEL_ACCURACY_THRESHOLD) {
    return theme.palette.warning.main;
  } else {
    return theme.palette.success.main;
  }
};

export const getModelMAPEColor = (value: number, theme: Theme): string => {
  if (value > MODEL_MAPE_THRESHOLD) {
    return theme.palette.warning.main;
  } else {
    return theme.palette.success.main;
  }
};

export const getModelBIColor = (value: number, theme: Theme): string => {
  if (value > MODEL_BUSINESS_ERROR_THRESHOLD) {
    return theme.palette.warning.main;
  } else {
    return theme.palette.success.main;
  }
};
